/**
 * Reload the page when a lazy chunk fails to load (Vite dispatches
 * `vite:preloadError` for failed dynamic imports / CSS preloads). This happens
 * when a long-lived tab runs HTML from a release whose hashed assets are no
 * longer deployed — reloading fetches fresh HTML that points at live assets.
 *
 * Throttled via sessionStorage so a genuinely broken deploy can't cause a
 * reload loop.
 */
const RELOAD_TS_KEY = "cohesive:preload-error-reload-ts";
const MIN_RELOAD_INTERVAL_MS = 60_000;

export function installReloadOnPreloadError(): void {
  window.addEventListener("vite:preloadError", (event) => {
    let lastReloadTs = 0;
    try {
      lastReloadTs = Number(sessionStorage.getItem(RELOAD_TS_KEY)) || 0;
    } catch {
      // sessionStorage unavailable — reload once anyway; without the throttle
      // marker a second failure in the same session will surface the error.
    }
    if (Date.now() - lastReloadTs < MIN_RELOAD_INTERVAL_MS) {
      return;
    }
    try {
      sessionStorage.setItem(RELOAD_TS_KEY, String(Date.now()));
    } catch {
      /* ignore */
    }
    event.preventDefault();
    window.location.reload();
  });
}
